import React, { Component } from 'react'
import styled from 'styled-components'
import { Input, Tooltip, Spin, Popconfirm, Button, Icon, Upload, Form, Collapse } from 'antd'

const { TextArea } = Input
const FormItem = Form.Item
const { Panel } = Collapse

const FilesUploadContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  -webkit-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
`

const EditAttachmentContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`
const EditAttachmentTitle = styled.h6`
  color: #fff;
`
const EditingFileContainer = styled.div`
  margin: 10px 0;
`

class Attachments extends Component {
  constructor(props) {
    super(props)
    this.state = {
      attachmentDetailsVisible: false
    }
  }

  uploadAttachment = uploadParam => {
    const formData = new FormData()

    formData.append('file', uploadParam.file)
    formData.append('type', 'company')
    formData.append('created_by_id', this.props.userId)
    formData.append('updated_by_id', this.props.userId)
    formData.append('filename', uploadParam.file.name)
    formData.append('description', uploadParam.file.name)
    formData.append('currentId', this.props.currentId)

    this.props.uploadAttachment({
      formData: formData
    })
  }

  handleAttachmentRowClick = row => {
    this.setState({
      attachmentDetailsVisible: true,
      attachmentId: row.id,
      attachmentName: row.filename,
      attachmentDescription: row.description
    })
  }

  onDescriptionChange = e => {
    this.setState({
      attachmentDescription: e.target.value
    })
  }

  handleUpdateAttachmentDescription = () => {
    this.props.updateAttachmentDescription({
      description: this.state.attachmentDescription,
      attachmentId: this.state.attachmentId,
      currentId: this.props.currentId,
      userId: this.props.userId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  confirmAttachmentDelete = event => {
    this.props.deleteAttachment({
      attachmentId: this.state.attachmentId,
      currentId: this.props.currentId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  getAttachments = () => {
    const { attachmentList } = this.props
    return (attachmentList || []).sort((a, b) => a.id - b.id)
  }

  renderElement = attachment => {
    const { filename, description, signedUrl, id } = attachment
    return (
      <Panel key={id} header={filename}>
        <div className="row">
          <div className="col-md-4">
            <div className="jobDetailsHeader">Filename:</div>
            <span>{filename}</span>
          </div>
          <div className="col-md-6">
            <div className="jobDetailsHeader">Description:</div>
            <span>{description}</span>
          </div>
          <div className="col-md-2">
            <div className="jobDetailsHeader">Actions:</div>
            <Tooltip placement="left" title="Edit file">
              <Icon
                type="edit"
                className="fontSize20"
                onClick={() => this.handleAttachmentRowClick(attachment)}
              />
            </Tooltip>
            <Tooltip placement="left" title="Open this file on a new window">
              <a target="_blank" href={signedUrl}>
                <Icon type="export" className="fontSize20" />
              </a>
            </Tooltip>
          </div>
        </div>
      </Panel>
    )
  }

  render() {
    const {
      attachmentList,
      loadingAttachments,
      uploadingAttachment,
      deletingAttachment
    } = this.props
    return (
      <FilesUploadContainer>
        <div className="row">
          <div className="col-md-6">
            <h5>
              <Icon type="file" /> Files
            </h5>
          </div>
          <div className="col-md-6 text-right">
            {uploadingAttachment && (
              <div className="text-success">
                <Icon type="loading" /> Uploading File(s)
              </div>
            )}
            {deletingAttachment && (
              <div className="text-danger">
                <Icon type="loading" /> Deleting File(s)
              </div>
            )}
          </div>
        </div>
        {attachmentList &&
          attachmentList.length > 0 && (
            <Spin spinning={loadingAttachments}>
              <Collapse>{this.getAttachments().map(this.renderElement)}</Collapse>
            </Spin>
          )}
        {this.state.attachmentDetailsVisible && (
          <EditAttachmentContainer>
            <EditAttachmentTitle>
              <Icon type="edit" /> Edit Attachment Area
            </EditAttachmentTitle>
            <div>
              <EditingFileContainer>
                <Icon type="file" /> {this.state.attachmentName}
              </EditingFileContainer>
            </div>
            <div className="row">
              <div className="col-md-10">
                <TextArea
                  placeholder="Describe the attachment..."
                  rows={4}
                  onChange={this.onDescriptionChange}
                  value={this.state.attachmentDescription}
                />
              </div>
            </div>
            <div className="d-flex flex-row mt-2">
              <Button onClick={this.handleUpdateAttachmentDescription}>
                <Icon type="save" /> OK
              </Button>{' '}
              <Popconfirm
                title="Are you sure you want to delete this attachment?"
                onConfirm={this.confirmAttachmentDelete}
                okText="Yes"
                cancelText="No"
              >
                <Button type="danger" icon="delete" className="ml-2">
                  {' '}
                  DELETE
                </Button>
              </Popconfirm>
            </div>
          </EditAttachmentContainer>
        )}
        <br />
        <FormItem label="Upload File(s)">
          <Upload
            name="file"
            customRequest={this.uploadAttachment}
            showUploadList={loadingAttachments}
          >
            <Button>
              <Icon type="upload" /> Upload
            </Button>
          </Upload>
        </FormItem>
      </FilesUploadContainer>
    )
  }
}

export default Attachments



// WEBPACK FOOTER //
// ./src/components/attachments/Attachments.js